import { ACTION_PREFIX } from '../../constants';

export const SET_INSURANCE_TYPE = `${ACTION_PREFIX}/SET_INSURANCE_TYPE`;

export function setInsuranceType(insuranceType) {
    return {
        type: SET_INSURANCE_TYPE,
        payload: {
            insuranceType,
        },
    };
}
